import { Button } from '@radix-ui/themes';

export default Button;
